import React from "react"
import ScrollPosition from "../../hook/ScrollPosition";

import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const F2floor = () => {
   const scrollPosition = ScrollPosition()
   return (
      <div className='Floor flexCenter'>
         <img src={require("../../img/shop/3f.png")} alt="" />
         <div className={`${scrollPosition >= 500 ? 'originPosition' : ''}`}>
            <h2>site.A301     DOORS</h2>
            <Swiper className='ShopSlide-cover' style={{
                "--swiper-pagination-color": "lavender",
                "--swiper-navigation-color": "lavender",
            }}
              // install Swiper modules
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              slidesPerView={1} navigation loop = {true}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/doors-01.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
            </Swiper>
            <p className="mb60">브랜드 뿐만 아니라 콘텐츠를 담고 있는 모든 매개체의 다양한 세계를 보여주는 도어스의 첫 번째 문이자 팝업 공간입니다.</p>
            <a className="link-arrow" href="noscrupt:">INFORMATION</a>
         </div>

         <div className={`${scrollPosition >= 1300 ? 'originPosition' : ''}`}>
            <h2>site.A302     글월</h2>
            <Swiper className='ShopSlide-cover' style={{
                "--swiper-pagination-color": "lavender",
                "--swiper-navigation-color": "lavender",
            }}
              // install Swiper modules
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              slidesPerView={1} navigation loop = {true}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/geulwoll-01.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
            </Swiper>
            <img src={require("../../img/logo/logo_geulwoll.png")} alt='' style={{width:'150px'}} />
            <p>Stationery, book</p>
            <p>글월(geulwoll)은 편지를 높이는 순우리말입니다. 이 이름으로 2019년 6월 편지 가게를 시작했습니다. 편지와 관련된 제품 및 서비스를 제안하며 잊혀져 가는 편지 문화를 동시대의 문화로 만들기 위한 즐거운 시도를 도모하고 있습니다. 감각적인 디자인과 서정적인 분위기를 조화롭게 풀어내어 국내 편지 디자인의 수준을 한 단계 끌어 올리며 젊은 세대의 응원을 받고 있습니다.</p>
            <p className="mb60">더불어 ‘편지 문화’에 뜻을 같이 하는 브랜드(ex. 아틀리에 드 에디토, 웬아이워즈영, 현대백화점 기프트 페이지, 롯데 리조트 등)와 여러 차례 콜라보레이션을 진행해 여전히 쓰는 사람들을 위한 경험 또한 제공하는 중입니다. 현재는 서울 연희동에 한 곳의 오프라인 숍을 운영중이며, 온라인 사이트와 SNS로 제품과 소식을 전하고 있습니다.</p>

            <span>Directions: A302</span>
            <span className="mb20">Opening hours: 화 - 일 / 12AM - 7PM (월 휴무)</span>
            <a className="link-arrow" href="noscrupt:">INSTAGRAM</a>
            <a className="link-arrow" href="noscrupt:">E,MAIL</a>
         </div>

         <div className={`${scrollPosition >= 2900 ? 'originPosition' : ''}`}>
            <h2>site.A303     듀이데저트 (Dewy desert)</h2>
            <Swiper className='ShopSlide-cover' style={{
                "--swiper-pagination-color": "lavender",
                "--swiper-navigation-color": "lavender",
            }}
              // install Swiper modules
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              slidesPerView={1} navigation loop = {true}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/dewydesrt-01.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
            </Swiper>
            <img src={require("../../img/logo/logo_dewydesert.png")} alt='' style={{width:'150px'}} />
            <p>‘DEWY DESERT’는 우리를 둘러싼 일상 속 숨겨진 이면의 아름다움을 탐구하는 핸드메이드 주얼리 브랜드입니다.</p>
            <p className="mb60">어딘지 생경하고 상반된 것들의 조합은 낯설지만 익숙한 분위기를 선사합니다.</p>

            <span>Directions: A303</span>
            <span className="mb20">Opening hours: 화 – 일 / 11AM - 8PM (월요일 휴무)</span>
            <a className="link-arrow" href="noscrupt:">INSTAGRAM</a>
            <a className="link-arrow" href="noscrupt:">E,MAIL</a>
         </div>

         <div className={`${scrollPosition >= 4100 ? 'originPosition' : ''}`}>
            <h2>site.A304     한아조(Hanahzo)</h2>
            <Swiper className='ShopSlide-cover' style={{
                "--swiper-pagination-color": "lavender",
                "--swiper-navigation-color": "lavender",
            }}
              // install Swiper modules
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              slidesPerView={1} navigation loop = {true}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/hanahzo-01.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/hanahzo-02.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/hanahzo-03.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
            </Swiper>
            <img src={require("../../img/logo/logo_hanahzo.png")} alt='' style={{width:'150px'}} />
            <p>Beauty, Life style, Fashion</p>
            <p>한아조(Hanahzo)는 ‘Pause your life’를 슬로건으로 모든 이의 휴식시간을 더 온전한 순간으로 만드는 데에 집중하며 브랜드를 전개합니다. 한아조는 우리가 더불어 살아가고 있는 환경을 고려하며 온전히 나만의 시간을 함께할 것들을 고민합니다.</p>
            <p className="mb60">한아조의 모든 것을 ‘한아조 답게’ 만들고자 합니다.</p>

            <span>Directions: A304</span>
            <span className="mb20">OOpening hours: 화 - 일 / 12PM - 8PM (월 휴무)</span>
            <a className="link-arrow" href="noscrupt:">INSTAGRAM</a>
            <a className="link-arrow" href="noscrupt:">E,MAIL</a>
         </div>
      </div>
   )
}

export default F2floor
